var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',_vm._g(_vm._b({staticClass:"input",attrs:{"placeholder":_vm.placeholder,"type":"text"},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }